import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const CharacterUploadCard = styled.label`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 180px;
    margin-top: 64px;
    padding: 1px 13px;
    border: 2px solid ${theme.stroke.stroke_1};
    border-radius: 8px;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.5);
    color: ${theme.content.hierarchy1};
    cursor: pointer;
    gap: 8px;
    backdrop-filter: blur(12px);

    ${theme.fontStyle.text.body14_medium};

    input {
      display: none;
    }

    &.on {
      cursor: auto;
    }
  `}
`;

export const DocumentImg = styled.img`
  width: 94px;
  height: 94px;
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body18_medium};
  `}
`;

export const FileName = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.content_light_3};
    ${theme.fontStyle.text.body14_medium};

    &.on {
      text-decoration: underline;
    }
  `}
`;
